/* eslint-disable css-modules/no-unused-class */
import { useDispatch, useSelector } from 'react-redux';

// Design System
import cardImage from 'jl-design-system/assets/images/gift-options/gift-card-guide.svg';

// Types
import { AppDispatch, RootState } from 'types/RootState.types';
import { ApplyGiftCardProps } from './ApplyGiftCard.types';

// Config
import applyGiftCardState from './ApplyGiftCard.state';
import paymentTypeConstants from '@constants/paymentTypeConstants';
import { applyGiftCard } from '@redux/actions/payment/applyGiftCardActions';
import { applyGiftCardFormConfig } from '@utils/form/configs/giftOptions';

// Components
import ApplyGenericGiftOption from './ApplyGenericGiftOption';

// Styles
import styles from './apply-gift-options-forms.scss';

const formConfig = applyGiftCardFormConfig();

const ApplyGiftCard = ({
  onDone = () => {},
  onRemove = () => {},
  onUndo = () => {},
  renderingContext = '',
}: ApplyGiftCardProps) => {
  const dispatch: AppDispatch = useDispatch();
  const {
    applyGiftPaymentFailed,
    errorMessage,
    formSubmitFailed,
    giftCardsList = [],
    isGiftCardAmountZero,
    isLoading,
    outstandingBalance = '',
    removeGiftOptionLoading,
    values = {},
  } = useSelector((state: RootState) => applyGiftCardState(state, renderingContext));

  const onDoneClickHandler = () => {
    if (!formSubmitFailed || Object.keys(values).length === 0) {
      onDone();
    }
  };

  const onFormSubmitHandler = (formValues: { giftCardNumber: string; giftCardPin: string }) => {
    const { giftCardNumber: cardNumber, giftCardPin: pin } = formValues;
    return dispatch(applyGiftCard({ cardNumber, pin }));
  };

  return (
    <ApplyGenericGiftOption
      applyGiftPaymentFailed={applyGiftPaymentFailed}
      cardImage={cardImage}
      doneButtonDataTest="apply-gift-card-button-done"
      doneButtonText="Done"
      errorMessage={errorMessage}
      formConfig={formConfig}
      formContainerClassName={styles.giftCardFormContainer}
      formDataTest="gift-card-form"
      formSubmitFailed={formSubmitFailed}
      hiddenAlertSubmittingText="Please wait, Gift card is submitting"
      instructionalText="Enter the 19-digit card number and 4-digit pin (scratch-off panel)"
      instructionalTextDataTest="gift-card-instructional-text"
      isLoading={isLoading}
      isZeroAmount={isGiftCardAmountZero}
      items={giftCardsList}
      onDoneClick={onDoneClickHandler}
      onFormSubmit={onFormSubmitHandler}
      onRemove={onRemove}
      onUndo={onUndo}
      outstandingBalance={outstandingBalance}
      removeGiftOptionLoading={removeGiftOptionLoading}
      type={paymentTypeConstants.GIFT_CARD}
    />
  );
};

export default ApplyGiftCard;
